var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal-container" }, [
    _c(
      "div",
      { staticClass: "modal-header" },
      [
        !_vm.isEdit
          ? _c("span", [_vm._v("Add Team Member Custom Field")])
          : _c("span", [_vm._v("Edit " + _vm._s(_vm.customField.label))]),
        _c(
          "md-button",
          {
            staticClass: "md-simple md-just-icon md-round modal-default-button",
            on: {
              click: function ($event) {
                $event.stopPropagation()
                return _vm.$modal.hide($event)
              },
            },
          },
          [_c("md-icon", [_vm._v("clear")])],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "modal-body" },
      [
        _c(
          "form-wrapper",
          {
            staticClass: "form-wrapper",
            attrs: { validator: _vm.$v.localModel },
          },
          [
            !_vm.isEdit
              ? _c(
                  "form-group",
                  [
                    _c(
                      "md-select",
                      {
                        on: { "md-selected": _vm.createFieldGroup },
                        model: {
                          value: _vm.selectedFieldGroup,
                          callback: function ($$v) {
                            _vm.selectedFieldGroup = $$v
                          },
                          expression: "selectedFieldGroup",
                        },
                      },
                      [
                        _c("md-option", { attrs: { value: "" } }, [
                          _vm._v("Please select"),
                        ]),
                        _vm._l(_vm.sortedFieldGroupOptions, function (grp) {
                          return _c(
                            "md-option",
                            { key: grp.value, attrs: { value: grp.value } },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(grp.label) +
                                  "\n                    "
                              ),
                            ]
                          )
                        }),
                      ],
                      2
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm.showFields
              ? [
                  !_vm.isStandaloneField
                    ? _c(
                        "form-group",
                        { attrs: { label: "Group Label", name: "groupLabel" } },
                        [
                          _c("md-input", {
                            model: {
                              value: _vm.localModel.label,
                              callback: function ($$v) {
                                _vm.$set(_vm.localModel, "label", $$v)
                              },
                              expression: "localModel.label",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "fieldset",
                    _vm._l(_vm.localModel.fields, function (fld, ndx) {
                      return _c(
                        "div",
                        { key: "field-" + ndx, staticClass: "field-group" },
                        [
                          _c(
                            "form-group",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.isEdit,
                                  expression: "isEdit",
                                },
                              ],
                              attrs: { label: "Field Name", name: "fieldName" },
                            },
                            [
                              _c("md-input", {
                                attrs: { disabled: "" },
                                model: {
                                  value: fld.name,
                                  callback: function ($$v) {
                                    _vm.$set(fld, "name", $$v)
                                  },
                                  expression: "fld.name",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "form-group",
                            {
                              attrs: {
                                label: "Field Label",
                                name: "fieldLabel",
                              },
                            },
                            [
                              _c("md-input", {
                                model: {
                                  value: fld.label,
                                  callback: function ($$v) {
                                    _vm.$set(fld, "label", $$v)
                                  },
                                  expression: "fld.label",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "form-group",
                            { attrs: { name: "type" } },
                            [
                              _vm.customFieldTypes
                                ? _c("vue-select", {
                                    attrs: {
                                      disabled: !_vm.isStandaloneField,
                                      options: _vm.customFieldTypes,
                                      placeholder: "Type",
                                      searchable: _vm.$root.isDesktop,
                                    },
                                    model: {
                                      value: fld.type,
                                      callback: function ($$v) {
                                        _vm.$set(fld, "type", $$v)
                                      },
                                      expression: "fld.type",
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    }),
                    0
                  ),
                ]
              : _vm._e(),
          ],
          2
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "modal-footer" },
      [
        _c(
          "md-button",
          {
            staticClass: "dialog-button md-primary",
            on: { click: _vm.validate },
          },
          [
            _vm._v(
              "\n            " +
                _vm._s(_vm.isEdit ? "Save" : "Add") +
                "\n        "
            ),
          ]
        ),
        _c(
          "md-button",
          {
            staticClass: "dialog-button md-default",
            on: {
              click: function ($event) {
                $event.stopPropagation()
                return _vm.$modal.hide($event)
              },
            },
          },
          [_vm._v("\n            Cancel\n        ")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }